module.exports = __webpack_public_path__ + "img/1.4360036a.jpg";